import { Component, OnInit, Output, Input, EventEmitter, HostListener } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { LonglineGear } from 'src/app/shared/longline-gear.model';
import { LookupItem } from 'src/app/shared/lookup-item.model';
import { lookupItemValidator } from 'src/app/shared/trip-validator.model';

/**
 * Longline form to display in gear-select-dialog
 */
@Component({
    selector: 'app-longline-form',
    templateUrl: './longline-form.component.html',
    styleUrls: ['./longline-form.component.css'],
    standalone: false
})
export class LonglineFormComponent implements OnInit {

  // back to gear type
  @Output() cancelEvent: EventEmitter<string> = new EventEmitter<string>();

  @Output() gearAddEvent: EventEmitter<LonglineGear> = new EventEmitter<LonglineGear>();

  /* Form controls */
  longlineForm = new FormGroup({
    name: new FormControl(''),
    longlineType: new FormControl(new LookupItem(''), [Validators.required, lookupItemValidator()]),
    skateLength: new FormControl('', [Validators.required]),
    hookSize: new FormControl('', [Validators.required]),
    hookSpace: new FormControl('', [Validators.required]),
    numHooksPerTub: new FormControl('', [Validators.required]),
    //numSkatesLost: new FormControl('', [Validators.required]),
    isFloating: new FormControl(false, [Validators.required])
  });

  @Input() line: LonglineGear = new LonglineGear();

  @Input() types: LookupItem[] = [];

  @Input() isEdit: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == 'Enter') this.onConfirmBtnClick()
  }

  onConfirmBtnClick() {
    if (this.longlineForm.valid) {
      let form = this.longlineForm.value;

      let newLine = new LonglineGear();
      //Form must be validated before this
      if (this.isEdit) newLine.identifier = form.name as string;
      newLine.gearSubtype = LookupItem.transformAnonymous(form.longlineType!);
      newLine.skateLength = Number.parseInt(form.skateLength!);
      newLine.hookSize = Number.parseInt(form.hookSize!);
      newLine.hookSpacing = Number.parseInt(form.hookSpace!);
      newLine.numHooksPerSkateTub = Number.parseInt(form.numHooksPerTub!);
      //newLine.totalNumLostSkatesTubs = Number.parseInt(form.numSkatesLost!);
      newLine.isFloatingLongline = form.isFloating!;
   
      this.gearAddEvent.emit(newLine);
    }
    this.longlineForm.markAllAsTouched();
  }


  ngOnChanges() {
    if (!this.line.skateLength) return;
    this.longlineForm.setValue(
      {
        name: this.line.identifier,
        longlineType: this.line.gearSubtype,
        skateLength: this.line.skateLength.toString(),
        hookSize: this.line.hookSize.toString(),
        hookSpace: this.line.hookSpacing.toString(),
        numHooksPerTub: this.line.numHooksPerSkateTub.toString(),
        //numSkatesLost: this.line.totalNumLostSkatesTubs.toString(),
        isFloating: this.line.isFloatingLongline
      }
    );
  }

  handleKeyUp(key: any) {
    if (key.keyCode == 13) this.onConfirmBtnClick();
  }

  compareFn(l1: LookupItem, l2: LookupItem): boolean {
    return l1 && l2 ? l1.code === l2.code : l1 === l2;
  }


  _forbidNonNumeric(control: AbstractControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ''));
  }

}
